export const sidebarLinks = [
  {
    name: "Dashboard",
    label: "Dashboard",
    link: "/",
    img: "/icons/Dashboard.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Dashboard",
  },
  {
    name: "Bajaj Dashboard",
    label: "Bajaj Dashboard",
    link: "/BajajDashboard",
    img: "/icons/bajajDashboard.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "BajajDashboard",
  },

  {
    label: "Role",
    name: "role",
    link: "/role",
    img: "/icons/role.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Role",
  },

  // {
  //   label: "mmtc Buy Response",
  //   name: "mmtc_buy_response",
  //   link: "/mmtc_buy_response",
  //   img: "/icons/Mmtc buy response.png",
  //   img2: "/icons/Adhar2.png",
  //   ApiKeyForSideBar: "aa",
  // },
  {
    label: "BUY",
    name: "BUY",
    link: "/BUY",
    img: "/icons/buy.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "BUY",
  },
  {
    label: "Content",
    name: "Content",
    link: "/Content",
    img: "/icons/content.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Content",
  },

  {
    label: "Jewellery",
    name: "Jewellery",
    link: "/Jewellery",
    img: "/icons/jewelleryicon.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Jewellery",
  },
  {
    label: "Operations",
    name: "Operations",
    link: "/Operations",
    img: "/icons/operations.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Operations",
  },
  {
    label: "Partners",
    name: "Partners",
    link: "/Partners",
    img: "/icons/Partner.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Partners",
  },

  {
    label: "Redeem",
    name: "Redeem",
    link: "/Redeem",
    img: "/icons/redeem-17.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Redeem",
  },


  {
    label: "Reports",
    name: "Reports",
    link: "/Reports",
    img: "/icons/Reports.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Reports",
  },



  {
    label: "SELL",
    name: "SELL",
    link: "/SELL",
    img: "/icons/sell.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SELL",
  },

  {
    label: "User",
    name: "User",
    link: "/user",
    img: "/icons/Users.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Users",
  },

];






export const BuyLinks = [
  {
    label: "Augmont Buy Invoices",
    name: "buy_invoices",
    link: "/buy_invoices",
    img: "/icons/Buy invoice.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "BuyInvoice",
  },
  {
    label: "Augmont Buy Requests",
    name: "buy_requests",
    link: "/buy_requests",
    img: "/icons/Buy request.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "BuyRequest",
  },
  {
    label: "Augmont Buy Response",
    name: "buy_response",
    link: "/buy_response",
    img: "/icons/buy response.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "BuyResponse",
  },
  {
    label: "MMTC Buy Request",
    name: "MMTCBuyRequest",
    link: "/MMTCBuyRequest",
    img: "/icons/buy request mmtc.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "MMTCBuyRequest",
  },
  {
    label: "MMTC Buy Response",
    name: "MMTCBuyResponse",
    link: "/MMTCBuyResponse",
    img: "/icons/buy response mmtc.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "MMTCBuyResponse",
  },

];
export const SellLinks = [
  // {
  //   label: "Augmont Sell Invoices",
  //   name: "sell_invoices",
  //   link: "/sell_invoices",
  //   img: "/icons/Sell Invoice.png",
  //   img2: "/icons/Adhar2.png",
  //   ApiKeyForSideBar: "SellInvoices",
  // },

  {
    label: "Augmont Sell Response",
    name: "sell_response",
    link: "/sell_response",
    img: "/icons/Sell Invoice.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SellInvoices",
  },
  {
    label: "Augmont Sell Requests",
    name: "sell_requests",
    link: "/sell_requests",
    img: "/icons/Sell request.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SellRequests",
  },
  {
    label: "MMTC Sell Request",
    name: "MMTCSellRequest",
    link: "/MMTCSellRequest",
    img: "/icons/sell request mmtc.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "MMTCSellRequest",
  },
  {
    label: "MMTC Sell Response",
    name: "MMTCSellResponse",
    link: "/MMTCSellResponse",
    img: "/icons/sell response mmtc.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "MMTCSellResponse",
  },
];
export const RedeemLinks = [
  {
    label: "Augmont Redeems",
    name: "redeems",
    link: "/redeems",
    img: "/icons/redeem augmont.png",
    ApiKeyForSideBar: "Redeems",
  },
  {
    label: "MMTC Redeems",
    name: "MMTCRedeems",
    link: "/MMTCRedeems",
    img: "/icons/redeem mmtc.png",
    ApiKeyForSideBar: "MMTCRedeems",
  },

];
export const ContentLinks = [

  {
    label: "App Banner",
    name: "app_banner",
    link: "/app_banner",
    img: "/icons/App banner.png",
    ApiKeyForSideBar: "AppBanner",
  },
  {
    label: "Blog",
    name: "blog",
    link: "/blog",
    img: "/icons/Blog.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Blog",
  },
  {
    label: "Collateral Upload",
    name: "CollateralUpload",
    link: "/CollateralUpload",
    img: "/icons/Collateral.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "CollateralUpload",
  },
  {
    label: "Faq",
    name: "Faq",
    link: "/Faq",
    img: "/icons/Faq.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Faq",
  },
  {
    label: "Home Banner",
    name: "HomeBanner",
    link: "/HomeBanner",
    img: "/icons/homebanner.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "HomeBanner",
  },
  // {
  //   label: "Media Coverage",
  //   name: "MediaCoverage",
  //   link: "/MediaCoverage",
  //   img: "/icons/mediacoverage.png",
  //   img2: "/icons/Adhar2.png",
  //   ApiKeyForSideBar: "MediaCoverage",
  // },
  {
    label: "Notification",
    name: "Notification",
    link: "/sendnotification",
    img: "/icons/Notification.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Notification",
  },
  {
    label: "Policy",
    name: "Policy",
    link: "/Policy",
    img: "/icons/policy.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Policy",
  },
  {
    label: "Template Creation",
    name: "TemplateCreation",
    link: "/TemplateCreation",
    img: "/icons/templateCreation.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "TemplateCreation",
  },

  {
    label: "Web Banner",
    name: "web_banner",
    link: "/web_banner",
    img: "/icons/Web banner.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "WebBanner",
  },

];
export const ReportsLinks = [
  {
    label: "Compliance Report",
    name: "ComplianceReport",
    link: "/ComplianceReport",
    img: "/icons/Compliance Report.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "ComplianceReport",
  },
  {
    label: "File Import History",
    name: "FileImportHistory",
    link: "/FileImportHistory",
    img: "/icons/File Import History.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "FileImportHistory",
  },

  {
    label: "Inactive Client",
    name: "InactiveClient",
    link: "/InactiveClient",
    img: "/icons/Inactive Client.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "InactiveClient",
  },
  {
    label: "Lumpsum",
    name: "Lumpsum",
    link: "/Lumpsum",
    img: "/icons/Lumpsum.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Lumpsum",
  },

  {
    label: "Missing SIP",
    name: "MissingSIP",
    link: "/MissingSIP",
    img: "/icons/Missing SIP.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "MissingSIP",
  },
  {
    label: "Sip Booked",
    name: "SipBooked",
    link: "/SipBooked",
    img: "/icons/SIP Booked.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SipBooked",
  },
  {
    label: "SIP Business Report",
    name: "SIPBussinessReport",
    link: "/SIPBussinessReport",
    img: "/icons/SIP Buisness Report.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SIPBussinessReport",
  },
  {
    label: "SIP Mining",
    name: "SIPMining",
    link: "/SIPMining",
    img: "/icons/Sip mining.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SIPMining",
  },


];
export const PartnerLinks = [
  {
    label: "Active/Inactive Partner",
    name: "ActivePartner",
    link: "/ActivePartner",
    img: "/icons/Activeinactivepartner.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "ActivePartner",
  },
  {
    label: "Batuk Partner",
    name: "BatukPartner",
    link: "/BatukPartner",
    img: "/icons/partner registration.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "BatukPartner",
  },
  {
    label: "B2C Report",
    // label: "Partner Day Report",
    name: "PartnerTransaction",
    link: "/PartnerTransaction",
    img: "/icons/partnerdayreport.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "PartnerTransaction",
  },
  {
    label: "Distributor Report",
    name: "DistributorReport",
    link: "/DistributorReport",
    img: "/icons/distributorreport.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "DistributorReport",
  },
  {
    label: "Mandate",
    name: "Partner SIP",
    link: "/mandate",
    img: "/icons/mandates.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Mandates",
  },
  {
    label: "MFD",
    name: "mutualFund",
    link: "/mutualFund",
    img: "/icons/mfd.png",
    img2: "/icons/Partner_invoice.png",
    ApiKeyForSideBar: "mutualFund",
  },

  {
    label: "Partner Commisssion",
    name: "partnerCommisssionReport",
    link: "/partnerCommisssionReport",
    img: "/icons/partnerCommision.png",
    img2: "/icons/Partner_invoice.png",
    ApiKeyForSideBar: "partnerCommisssionReport",
  },

  {
    label: "Partner Employees",
    name: "employees",
    link: "/employees",
    img: "/icons/Employees.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Employees",
  },

  {
    label: "Partner Invoice",
    name: "PartnerInvoice",
    link: "/PartnerInvoice",
    img: "/icons/Partner_invoice.png",
    img2: "/icons/Partner_invoice.png",
    ApiKeyForSideBar: "PartnerInvoice",
  },
  {
    label: "Partner Login Tables",
    name: "login_tables",
    link: "/login_tables",
    img: "/icons/Login tables.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "LoginTables",
  },
  {
    label: "Partner Registerations",
    name: "partner_registerations",
    link: "/partner_registerations",
    img: "/icons/partner registration.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "PartnerRegisterations",
  },
  {
    label: "Partner Report",
    name: "PartnerReport",
    link: "/PartnerReport",
    img: "/icons/partnerreport.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "PartnerReport",
  },



  {
    label: "Proposal",
    name: "proposal",
    link: "/proposals",
    img: "/icons/Proposal.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Proposals",
  },

]
export const UserLinks = [
  // {
  //   label: "Users",
  //   name: "users",
  //   link: "/users",
  //   img: "/icons/Users.png",
  //   img2: "/icons/Adhar2.png",
  //   ApiKeyForSideBar: "User",
  // },

  {
    label: "Addresses",
    name: "addresses",
    link: "/addresses",
    img: "/icons/Address.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Address",
  },
  {
    label: "Banks",
    name: "banks",
    link: "/banks",
    img: "/icons/Bank.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Banks",
  },


  {
    label: "Nominees",
    name: "nominees",
    link: "/nominees",
    img: "/icons/nominees.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Nominees",
  },
  {
    label: "PANs",
    name: "pans",
    link: "/pans",
    img: "/icons/Pan.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Pan",
  },
  {
    label: "Users",
    name: "users",
    link: "/users",
    img: "/icons/Users.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "User",
  },
];
export const JewelleryLinks = [
  {
    label: "Jewellery Catalogue",
    name: "jewellery_catalogue",
    link: "/jewellery_catalogue",
    img: "/icons/Jewellery Catalog.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "JewelleryCatalogue",
  },
  {
    label: "Jewellery Order",
    name: "order",
    link: "/order",
    img: "/icons/order.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Order",
  },
  {
    label: "Jewellery Quote",
    // label: "Spot Gold Queries", name changes 
    name: "SpotGoldQueries",
    link: "/SpotGoldQueries",
    img: "/icons/Spot Gold Query.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SpotGoldQueries",
  },

];
export const OperationsLinks = [

   {
    label: "KYC Name Mismatch",
    name: "tradeFailed",
    link: "/kycnamemismatch",
    img: "/icons/Transaction.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "kycmismatch",
  },
 
  {
    label: "Trade Failed",
    name: "tradeFailed",
    link: "/tradefailed",
    img: "/icons/Transaction.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "tradefailed",
  },

   {
    label: "Send Report",
    name: "report",
    link: "/report",
    img: "/icons/Transaction.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "sendReport",
  },

  {
    label: "MMTC Sell Quote",
    name: "transactions",
    link: "/sell-quote",
    img: "/icons/Transaction.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "mmtcSellQuote",
  },
  {
    label: "All Transactions",
    name: "transactions",
    link: "/transactions",
    img: "/icons/Transaction.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Transactions",
  },
  {
    label: "DSR",
    name: "Dsr",
    link: "/Dsr",
    img: "/icons/Dsr.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Dsr",
  },
  {
    label: "Fintso Transactions",
    name: "FintsoTransactions",
    link: "/FintsoTransactions",
    img: "/icons/Fintso transaction.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "fintsoTransactions",
  },
  {
    label: "Gift Card Partner",
    // label: "Gift Card", name changed
    name: "GiftCard",
    link: "/GiftCard",
    img: "/icons/Giftcard.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "GiftCard",
  },
  {
    label: "Gift Card User",
    name: "GiftCardUser",
    link: "/GiftCardUser",
    img: "/icons/gift card user.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "GiftCardUser",
  },

  {
    label: "KYC Update",
    // label: "kycUpdate",
    name: "kycUpdate",
    link: "/kycUpdate",
    img: "/icons/Kyc Update.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "kycUpdate",
  },
  {
    label: "Queries",
    name: "queries",
    link: "/queries",
    img: "/icons/Queries.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Queries",
  },
  {
    label: "Sales Target",
    name: "SalesTarget",
    link: "/SalesTarget",
    img: "/icons/sales target.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "SalesTarget",
  },
  {
    label: "SIP",
    // label: "Sip",
    name: "sip",
    link: "/sip",
    img: "/icons/Sip.png",
    img2: "/icons/Adhar2.png",
    ApiKeyForSideBar: "Sip",
  },





];